import { Book, Chapter } from '../../types';
import './chapter-navigation.css';

interface ChapterNavigationProps {
  prevChapter?: Chapter;
  nextChapter?: Chapter;
  book: Book;
}

export const ChapterNavigation = ({
  prevChapter,
  nextChapter,
  book,
}: ChapterNavigationProps) => {
  return (
    <div class="chapter-navigation">
      {prevChapter && (
        <a
          role="button"
          className="secondary"
          href={`/f/${book.permalink}/c/${prevChapter.permalink}`}
        >
          Previous Chapter
        </a>
      )}
      {!prevChapter && (
        <a role="button" className="secondary" href={`/f/${book.permalink}`}>
          Back to Book
        </a>
      )}
      {nextChapter && (
        <a
          role="button"
          href={`/f/${book.permalink}/c/${nextChapter.permalink}`}
        >
          Next Chapter
        </a>
      )}
    </div>
  );
};
